
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-client/lib/index.js
 ** module id = 684
 ** module chunks = 0 5
 **/